export default {
    methods: {
        getImagePath(path, filter = null) {
            // let url = window.mediaUrl + '/media/cache/' + filter + '/' + path;
            // let url = window.mediaUrl + '/media/cache/' + filter + '/' + path;
            // let cachedUrl = window.mediaUrl + '/media/cache/resolve/' + filter + '/' + path;
            //
            if (filter == null) {
                return window.mediaUrl + '/' + path;
            }
            //
            // return cachedUrl;
            let url = window.mediaUrl + '/media/cache/' + filter + '/' + path;
            return url;
        }
    }
}
